import classNames from "classnames";
import Box from "../../components/Box";
import Button from "../../components/Button";
import Text from "../../components/Text";

interface Props {
    badge?: string; title?: string; desc?: string; grdBtn?: string; outBtn?: string; avatar?: string; avatarBoxClass?: string; avatarClassName?: string; frame?: string; customFrame?: string | React.ReactNode;
}

export default function EndingSection({ badge, title, desc, grdBtn, outBtn, avatar, avatarBoxClass, avatarClassName, frame, customFrame }: Props) {

    return <Box
        leftBlock={
            <div className='col-span-2 md:col-span-1 p-7 text-center my-20 md:my-0'>
                <div className="text-center">
                    {/* {!!badge && <Text type={"highlighter"} label={badge} />} */}
                    {!!title && <Text type={"cardTitle"} cName="text-balance text-4xl md:text-4xl sm:text-3xl font-semibold tracking-tight text-[#0C0C0C]" label={title} />}
                    {!!desc && <div className="flex justify-center">
                        <Text type="description" cName="mt-2 text-xs text-[#4D4D4D] text-pretty font-medium max-w-xl" label={desc} />
                    </div>}
                </div>
                {(!!grdBtn || !!outBtn) && <div className="flex md:flex-col justify-center items-center gap-6 mt-8">
                    {!!grdBtn && <Button label={grdBtn} type='gradient' />}
                    {!!outBtn && <Button label={outBtn} type='outlined' />}
                </div>}
            </div>
        }
        rightBlock={
           (!!avatar || !!frame || !!customFrame) && <div className="col-span-2 relative">
                {!!avatar && <div className={classNames("absolute -top-[80%] right-0 z-[-10] md:hidden", avatarBoxClass)}>
                    <img className={classNames(avatarClassName || "max-w-xs")} src={avatar} alt={title} />
                </div>}
                {!!frame && <div className="z-10">
                    <img src={frame} alt={desc} />
                </div>}
                {!!customFrame && customFrame}
            </div>
        }
    />
}